export default {
  seo: {
    home: {
      title: "IGNIVA — Surfaces et solutions pour l'architecture et l'intérieur",
      desc: "IGNIVA sélectionne et représente des marques internationales de matériaux, de surfaces et de technologie pour l'architecture et l'intérieur. Lithotech, en distribution exclusive au Portugal par IGNIVA.",
    },
    about: {
      title: "À propos d'IGNIVA — Sélection, soutien technique et suivi commercial | IGNIVA",
      desc: "IGNIVA sélectionne des marques et des matériaux, accompagne la prescription et travaille avec des architectes, des designers, des studios de cuisine et de salle de bains, des marbriers et des fabricants de mobilier.",
    },
    brands: {
      title: "Marques et solutions | IGNIVA",
      desc: "Lithotech, Foster et Mastercharge : surfaces grand format, équipements de cuisine et recharge sans fil intégrée.",
    },
    applications: {
      title: "Applications — Cuisines, salles de bains, mobilier et revêtements | IGNIVA",
      desc: "Applications en cuisines, salles de bains, mobilier, revêtements, façades et technologie intégrée, avec les marques présentées par IGNIVA.",
    },
    explorer: {
      title: "Explorer les solutions | IGNIVA",
      desc: "Découvrez des surfaces et des solutions par marque, application et caractéristique, et demandez des informations avec le contexte déjà défini.",
    },
    professionals: {
      title: "Professionnels — Architectes, designers, cuisine et salle de bains | IGNIVA",
      desc: "Informations, documentation officielle et soutien à la prescription pour les architectes, designers, studios de cuisine et de salle de bains, marbriers et fabricants de mobilier.",
    },
    contacts: {
      title: "Contact | IGNIVA",
      desc: "Parlez-nous de votre projet : informations sur les produits, échantillons, documentation ou devis.",
    },
    quote: {
      title: "Demande de devis | IGNIVA",
      desc: "Demandez un devis : marque, application et détails du projet. Les prix dépendent de la validation des mesures, des matériaux et des détails techniques.",
    },
    privacy: { title: "Politique de confidentialité | IGNIVA", desc: "Comment IGNIVA traite les données personnelles recueillies sur ce site." },
    legal: {
      title: "Mentions légales | IGNIVA",
      desc: "Identification de la société IGNIVA Design & Surface Solutions, Unipessoal Lda.",
    },
  },
  nav: {
    home: "Accueil",
    about: "À propos",
    brands: "Marques",
    applications: "Applications",
    explorer: "Explorer les solutions",
    professionals: "Professionnels",
    contacts: "Contact",
    quote: "Demander un devis",
    menu_open: "Ouvrir le menu",
    menu_close: "Fermer le menu",
  },
  common: {
    all: "Toutes",
    all_m: "Tous",
    explore: "Explorer",
    request_info: "Demander des informations",
    request_quote: "Demander un devis",
    next: "Suivant",
    back: "Retour",
    submit: "Envoyer la demande",
    sending: "Envoi en cours…",
    close: "Fermer",
    official_site: "Site officiel de la marque",
    catalogue: "Catalogues et documentation",
    catalogue_note: "Les catalogues, fiches techniques et échantillons dépendent de chaque marque. Contactez IGNIVA pour savoir ce qui est disponible.",
    applications: "Applications",
    brand: "Marque",
    aesthetic: "Caractéristique",
    step: "Étape",
    of: "sur",
    origin: "Origine",
    scopes: "Applications",
    back_brands: "Retour aux marques",
    gallery: "Applications et inspiration",
    categories: "Produits et solutions",
    video: "Vidéo officielle",
    video_hint: "Lire la vidéo officielle de la marque (YouTube)",
    video_note: "À la lecture, la vidéo est chargée depuis YouTube, qui peut enregistrer des cookies dans votre navigateur.",
    docs: "Documentation officielle",
    image_note: "Photographie officielle de la marque, utilisée comme application ou inspiration. Elle ne montre pas de projets réalisés par IGNIVA.",
    pending_image: "Image officielle prochainement",
    brands_label: "Marques",
    exclusive_pt: "Distribution exclusive au Portugal par IGNIVA",
    know_brand: "Découvrir {name}",
  },
  home: {
    tag: "Architecture · Intérieur · Surfaces",
    h1a: "Surfaces et solutions",
    h1b: "pour des projets avec identité.",
    intro: "IGNIVA sélectionne et représente des marques internationales de matériaux, de surfaces et de technologie pour l'architecture et l'intérieur.",
    cta1: "Découvrir les marques",
    cta2: "Parlez-nous de votre projet",
    slides: [
      { a: "Cuisines", b: "Lithotech — composition de cuisine" },
      { a: "Plans de travail", b: "Lithotech — détail de plan de travail" },
      { a: "Surfaces", b: "Lithotech — finition de surface" },
    ],
    trust: [
      "Sélection rigoureuse de marques et de matériaux",
      "Soutien technique et à la prescription",
      "Un lien entre fabricants et professionnels",
    ],
    scroll: "Faites défiler pour découvrir",
    manifesto_tag: "Ce que nous faisons",
    manifesto_title: "Entre ceux qui fabriquent et ceux qui conçoivent.",
    manifesto_text: [
      "IGNIVA rapproche des marques internationales des professionnels de l'architecture et du design d'intérieur.",
      "Nous sélectionnons des matériaux et des solutions pour leur qualité, leur design et leur performance technique, en aidant les architectes, designers, studios de cuisine, fabricants et marbriers à les intégrer dans chaque projet.",
      "Notre travail associe connaissance des matériaux, soutien à la prescription et suivi commercial.",
    ],
    manifesto_cta: "À propos d'IGNIVA",
    roles: [
      {
        t: "Sélection",
        d: "Nous sélectionnons des marques et des matériaux pour leur qualité esthétique, leur performance technique et leur diversité d'applications.",
      },
      {
        t: "Soutien à la prescription",
        d: "Nous accompagnons les professionnels dans le choix des matériaux et des solutions, en fournissant des informations techniques et la documentation officielle des fabricants.",
      },
      {
        t: "Suivi commercial",
        d: "Nous faisons le lien entre fabricants et professionnels, en suivant les demandes d'informations, la prescription et le développement des opportunités.",
      },
    ],
    sectors_tag: "Pour qui",
    sectors: ["Architecture", "Design d'intérieur", "Cuisine et salle de bains", "Marbriers", "Mobilier", "Promoteurs"],
    brands_tag: "Marques",
    brands_title: "Marques et solutions",
    brands_sub: "Des marques internationales aux propositions distinctes pour l'architecture, l'intérieur et le mobilier. Matériaux, équipements et technologie sélectionnés pour leurs caractéristiques et leur diversité d'applications.",
    apps_tag: "Applications",
    apps_title: "Où chaque solution s'applique.",
    apps_cta: "Voir toutes les applications",
    explorer_tag: "Découverte",
    explorer_title: "Explorer les solutions",
    explorer_text: "Découvrez des matériaux et des solutions par marque, application et caractéristiques, et trouvez les informations les plus utiles pour votre projet.",
    explorer_cta: "Ouvrir l'explorateur",
    cta_title: "Parlez-nous de votre projet.",
    cta_text: [
      "Vous cherchez des informations sur des matériaux, équipements ou solutions pour un projet ?",
      "Contactez-nous pour demander une documentation technique, des échantillons ou un devis.",
    ],
    intro2: "Nous accompagnons les architectes, designers et autres professionnels dans le choix et la prescription de solutions pour cuisines, salles de bains, mobilier et revêtements.",
    apps_intro: "Matériaux, équipements et technologie pour différents espaces et besoins de projet.",
  },
  about: {
    tag: "À propos d'IGNIVA",
    title: "Entre ceux qui fabriquent et ceux qui conçoivent.",
    lead: "IGNIVA sélectionne des surfaces et des solutions pour l'architecture et l'intérieur, avec un soutien technique et commercial de proximité pour les professionnels. Nous choisissons les marques et les matériaux, aidons à la prescription et suivons chaque demande de près.",
    experience: "L'entreprise s'appuie sur l'expérience de son fondateur dans le secteur de la pierre et des surfaces, avec un parcours en gestion commerciale, développement de marchés et travail avec des réseaux de professionnels.",
    note: "IGNIVA n'est ni fabricant ni poseur.",
    note_text: "Les caractéristiques des produits appartiennent à chaque marque et figurent dans sa documentation officielle. IGNIVA assure la sélection, le soutien à la prescription et le suivi commercial.",
    pillars_tag: "Notre façon de travailler",
    pillars_title: "Trois façons d'accompagner votre projet.",
    pillars: [
      {
        n: "01",
        t: "Sélection",
        d: "Nous choisissons des marques et des matériaux pour leur qualité esthétique et technique et pour leur place dans les projets.",
      },
      {
        n: "02",
        t: "Soutien à la prescription",
        d: "Nous vous aidons à comprendre le matériau, ses applications et la documentation officielle de chaque marque, pour que le choix soit éclairé.",
      },
      {
        n: "03",
        t: "Suivi commercial",
        d: "Nous mettons en relation marques et professionnels, avec un contact de proximité dès la première demande d'informations.",
      },
    ],
    rel_tag: "Pour qui",
    rel_title: "Avec qui nous travaillons.",
    rel_text: "Architectes et designers d'intérieur, magasins et studios de cuisine et de salle de bains, marbriers, fabricants de mobilier et promoteurs de projets résidentiels, commerciaux et Hospitality. Nous parlons le langage technique de ceux qui prescrivent, avec la clarté nécessaire à ceux qui décident.",
    cta: "Parlez-nous de votre projet",
  },
  brands_page: {
    tag: "Marques",
    title: "Marques et solutions",
    sub: "Des marques internationales aux propositions distinctes pour l'architecture, l'intérieur et le mobilier. Matériaux, équipements et technologie sélectionnés pour leurs caractéristiques et leur diversité d'applications.",
    filter_all: "Toutes",
    cta: "Voir la marque",
  },
  brand: {
    lithotech: {
      tag: "Pierre frittée",
      origin: "Castellón, Espagne",
      headline: "Surfaces grand format.",
      categories: ["Plans de travail de cuisine", "Salles de bains", "Mobilier", "Revêtements"],
      short: "Surfaces en pierre frittée grand format pour plans de travail, revêtements, mobilier et autres applications architecturales. Une sélection de couleurs, de textures et de finitions qui allie expression esthétique, performance technique et polyvalence d'application.",
      long: [
        "Lithotech est une marque espagnole de pierre frittée, dont le siège et la production se trouvent à Castellón. Ses collections comprennent notamment Frame, Oda, Gubi et Allure.",
        "La marque développe sa propre technologie, comme Corelith® et 3D·Fit®, pour des surfaces avec relief et un frittage contrôlé. Les collections Frame, Oda et Gubi utilisent la 3D·Fit® pour faire coïncider le motif avec le relief de la surface.",
        "IGNIVA est le distributeur exclusif de Lithotech au Portugal. Les formats, épaisseurs, finitions et caractéristiques techniques de chaque collection figurent dans le catalogue officiel et les fiches techniques.",
      ],
      ambitos: ["Plans de travail de cuisine", "Salles de bains", "Mobilier", "Revêtements"],
      desc: [
        "Surfaces en pierre frittée grand format pour plans de travail, revêtements, mobilier et autres applications architecturales.",
        "Une sélection de couleurs, de textures et de finitions qui allie expression esthétique, performance technique et polyvalence d'application.",
      ],
    },
    foster: {
      tag: "Équipements pour cuisine",
      origin: "Brescello, Italie",
      headline: "Éviers et robinets pour la cuisine.",
      categories: ["Éviers", "Robinets"],
      short: "Équipements de cuisine en acier inoxydable, conçus avec une attention particulière au design, à la fonctionnalité et à l'intégration dans les espaces. Éviers, robinets, plaques de cuisson et autres solutions qui allient technologie et design italien.",
      long: [
        "Foster est une entreprise italienne fondée en 1973, dont le siège est à Brescello et qui compte quatre unités de production. Elle travaille l'acier inoxydable (AISI 304 et AISI 316) pour des éviers, robinets et autres équipements de cuisine.",
        "Les finitions de la marque comprennent l'acier satiné et des couleurs PVD telles que Gun Metal, Gold et Copper. Pour toute information sur les gammes et les finitions, contactez IGNIVA ou consultez le site officiel de la marque.",
      ],
      ambitos: ["Cuisines"],
      desc: [
        "Équipements de cuisine en acier inoxydable, conçus avec une attention particulière au design, à la fonctionnalité et à l'intégration dans les espaces.",
        "Éviers, robinets, plaques de cuisson et autres solutions qui allient technologie et design italien.",
      ],
    },
    mastercharge: {
      tag: "Recharge sans fil intégrée",
      origin: "Royaume-Uni",
      headline: "Votre téléphone se recharge dès que vous le posez sur le plan de travail.",
      categories: ["Recharge sous plans de travail", "Recharge dans le mobilier et les tables"],
      short: "Technologie de recharge sans fil intégrée sous des surfaces compatibles, qui permet de recharger des appareils sans chargeurs ni câbles visibles sur le plan de travail. Une solution discrète pour cuisines, tables et mobilier, qui ajoute de la fonctionnalité sans nuire au design.",
      long: [
        "Mastercharge développe des chargeurs sans fil (Qi) à installer sous les plans de travail, tables et meubles, sans rien de visible. Il suffit de poser le téléphone sur la surface pour lancer la recharge.",
        "La recharge traverse des matériaux comme le bois, la pierre et le verre, mais pas le métal. La distance maximale, la puissance et la compatibilité dépendent du modèle et du matériau : lisez le manuel officiel et contactez IGNIVA avant de prescrire.",
      ],
      ambitos: ["Plans de travail de cuisine", "Mobilier et tables"],
      desc: [
        "Technologie de recharge sans fil intégrée sous des surfaces compatibles, qui permet de recharger des appareils sans chargeurs ni câbles visibles sur le plan de travail.",
        "Une solution discrète pour cuisines, tables et mobilier, qui ajoute de la fonctionnalité sans nuire au design.",
      ],
    },
  },
  apps_page: {
    tag: "Applications",
    title: "Où chaque solution s'applique.",
    sub: "Choisissez une application pour voir les marques et les solutions correspondantes. Les images sont des photographies officielles des marques, utilisées comme application ou inspiration.",
    brands_for: "Marques pour cette application",
  },
  app_items: {
    cozinhas: "Cuisines",
    banhos: "Salles de bains",
    mobiliario: "Mobilier",
    revestimentos: "Revêtements",
    fachadas: "Façades",
    integrada: "Technologie intégrée",
  },
  app_cats: {
    cozinhas: "Cuisines",
    banhos: "Salles de bains",
    mobiliario: "Mobilier",
    revestimentos: "Revêtements",
    fachadas: "Façades",
    integrada: "Technologie intégrée",
  },
  categories: { superficies: "Surfaces", equipamento: "Équipements de cuisine", tecnologia: "Technologie intégrée" },
  explorer: {
    tag: "Découverte",
    title: "Explorer les solutions",
    sub: "Filtrez par marque, catégorie, application et caractéristique.",
    filter_brand: "Marque",
    filter_app: "Application",
    filter_aes: "Caractéristique",
    filter_cat: "Catégorie",
    empty: "Aucune solution ne correspond aux filtres sélectionnés.",
    detail_cta: "Demander des informations",
    detail_brand: "Marque",
  },
  explorer_items: {
    "lithotech-superficies": {
      name: "Surfaces Lithotech",
      desc: "Surfaces grand format pour plans de travail de cuisine, salles de bains et mobilier, selon la documentation technique de chaque produit.",
    },
    "lithotech-revestimentos": {
      name: "Revêtements grand format",
      desc: "Grand format pour revêtements intérieurs, selon le produit et la documentation officielle de la marque.",
    },
    "foster-lava-loucas": { name: "Éviers Foster", desc: "Éviers en acier inoxydable pour la cuisine." },
    "foster-torneiras": { name: "Robinets Foster", desc: "Robinets de cuisine dans différentes finitions." },
    "mastercharge-carregamento": {
      name: "Recharge sans fil intégrée",
      desc: "Recharge sans fil intégrée aux plans de travail, tables et meubles. La compatibilité dépend de la documentation technique de la marque.",
    },
  },
  aesthetics: { pedra: "Pierre", aco: "Acier inoxydable", integrado: "Intégré", grande_formato: "Grand format" },
  quote: {
    tag: "Devis",
    title: "Demande de devis",
    sub: "Quatre étapes simples. Les prix dépendent de la validation des mesures, des matériaux et des détails techniques ; nous répondons après analyse de votre demande.",
    steps: ["Marque", "Application", "Projet", "Contact"],
    s1_title: "Quelle marque vous intéresse ?",
    s2_title: "Quelle application ?",
    s3_title: "À propos du projet",
    tipo: "Type de projet",
    quantidade: "Quantité estimée (m², unités…)",
    localizacao: "Localisation du projet",
    tipos: {
      residencial: "Résidentiel",
      hospitality: "Hospitality",
      comercial: "Commercial",
      retalho: "Commerce de détail",
      outro: "Autre",
    },
    files_hint: "Vous avez des plans ou des fichiers techniques ? Après l'envoi de la demande, envoyez-les à",
    s4_title: "Vos coordonnées",
    review: "Récapitulatif de la demande",
    new: "Nouvelle demande",
  },
  pros: {
    tag: "Professionnels",
    title: "Des solutions pour ceux qui conçoivent et transforment.",
    sub: [
      "Nous travaillons avec des architectes, designers, studios de cuisine et de salle de bains, marbriers, fabricants de mobilier et promoteurs.",
      "Nous fournissons des informations sur les matériaux, une documentation technique et un soutien commercial pour faciliter le choix et l'intégration des solutions dans chaque projet.",
    ],
    benefits_tag: "Comment nous aidons",
    benefits_title: "Travailler avec IGNIVA",
    benefits: [
      "Une sélection réfléchie de marques et de matériaux",
      "La documentation officielle des marques pour soutenir la prescription",
      "Des échantillons, lorsque la marque les met à disposition",
      "Un interlocuteur unique pour les demandes d'informations et de devis",
    ],
    res_tag: "Ressources",
    res_title: "Documentation par marque",
    res_note: "Les catalogues, fiches techniques et échantillons dépendent de chaque marque. Vous pouvez consulter la documentation officielle publique ou nous demander des informations.",
    res_site: "Site officiel",
    res_docs: "Catalogues et documentation",
    form_tag: "Contact professionnel",
    form_title: "Présentez-vous à IGNIVA",
    tipo: "Profil professionnel",
    tipos: {
      arquiteto: "Architecte",
      designer: "Designer d'intérieur",
      estudio_cozinhas: "Magasin ou studio de cuisine et de salle de bains",
      marmorista: "Marbrier",
      fabricante: "Fabricant de mobilier",
      promotor: "Promoteur",
      outro: "Autre",
    },
    areas: [
      {
        t: "Informations techniques",
        d: "Accès à la documentation officielle des fabricants, aux caractéristiques des matériaux et aux recommandations d'application.",
      },
      {
        t: "Échantillons et matériaux",
        d: "Aide pour identifier les références et demander des échantillons en vue de l'évaluation et de la prescription.",
      },
      {
        t: "Suivi commercial",
        d: "Coordination avec les fabricants et les partenaires pour répondre aux demandes d'informations et développer les opportunités de projet.",
      },
    ],
  },
  contact: {
    tag: "Contact",
    title: "Parlez-nous de votre projet.",
    sub: "Informations sur les produits, échantillons, documentation ou devis : dites-nous ce que vous cherchez et nous vous répondrons par email.",
    assunto: "Type de demande",
    assuntos: { info: "Informations", amostras: "Échantillons", orcamento: "Devis", outro: "Autre" },
    email_label: "Email",
    phone_label: "Téléphone",
    form_title: "Envoyez votre message",
  },
  form: {
    nome: "Nom",
    empresa: "Entreprise",
    email: "Email",
    telefone: "Téléphone (facultatif)",
    atividade: "Activité professionnelle",
    mensagem: "Message",
    atividades: [
      "Architecture",
      "Design d'intérieur",
      "Magasin ou studio de cuisine et de salle de bains",
      "Marbrier",
      "Fabricant de mobilier",
      "Promoteur ou projets commerciaux",
      "Client particulier",
      "Autre",
    ],
    gdpr: "J'autorise le traitement de mes données pour répondre à cette demande, conformément à la",
    gdpr_link: "Politique de confidentialité",
    send: "Envoyer le message",
    required: "Champ obligatoire",
    success_title: "Merci de nous avoir contactés.",
    success_text: "Nous avons bien reçu votre demande et nous vous recontacterons dans les meilleurs délais.",
    error: "Votre demande n'a pas pu être envoyée. Veuillez réessayer ou nous contacter à l'adresse {email}.",
    another: "Envoyer une autre demande",
  },
  privacy: {
    tag: "Confidentialité",
    title: "Politique de confidentialité",
    updated: "Le texte juridique est disponible en portugais et reste soumis à la validation finale d'IGNIVA avant publication.",
  },
  footer: {
    tagline: "Sélection et représentation de marques internationales de matériaux, de surfaces et de technologie pour l'architecture et l'intérieur.",
    nav: "Navigation",
    brands: "Marques",
    contact: "Contact",
    rights: "Tous droits réservés.",
    privacy: "Politique de confidentialité",
    legal_info: "Mentions légales",
  },
  legal: {
    tag: "Mentions légales",
    title: "Identification de la société",
    intro: "Informations fournies en application de l'article 10 du décret-loi portugais 7/2004 (services de la société de l'information).",
    name: "Raison sociale",
    nif: "Numéro fiscal (NIF / NIPC)",
    seat: "Siège social",
    email: "Email",
  },
};
